import React from 'react';
import Footer from "components/Footer/Footer";
import Admin from "layouts/Admin";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";
import { createPrinter } from "typescript";

//Calling Bootstrap 4.5 css
import 'bootstrap/dist/css/bootstrap.min.css';
//Calling Firebase config setting to call the data
import firebase from "../firebase";
class emergencyrequest extends React.Component {
constructor(props) {
    
    super(props);
   
    this.state = {studentslist : []}
    }
    
  componentDidMount() {
   
   
      firebase.database().ref("emgrequest").on("value", snapshot => {
        let studentlist = [];
        snapshot.forEach(snap => {
            // snap.val() is the dictionary with all your keys/values from the 'students-list' path
            studentlist.push(snap.val());
        });
        this.setState({ studentslist: studentlist });
      });
    
 }
  
  render(){
  return (

    <>


 
    <Admin/>

<br/>

<Container>
  <Row>
    <Col md={{ span: 12, offset: 1 }}>  




    <Table striped bordered hover>
  <thead>
    <tr>
    <th>Driver ID</th>
    <th>Driver Name</th>
    <th>Location</th>
    <th>Request Type</th>
    <th>Time</th>
    <th>Date</th>
    <th>Incidence Description</th>
    <th><center></center></th>
    <th><center></center></th>
    
    </tr>
  </thead>
  <tbody>
  {this.state.studentslist.map(data => {
                
                return (
                    <tr>     
                    <td>{data.DriverID}</td>
                    <td>{data.DriverName}</td>
                    <td>{data.DriverLocation}</td>
                    <td>{data.RequestType}</td>
                    <td>{data.Time}</td>
                    <td>{data.Date}</td>
                    <td>{data.Description}</td>
                    <td><Button variant="info">Ok</Button>{' '} </td>
                    <td><Button variant="dark">Cancel</Button></td>
                    </tr>
  
  );
               
})}
</tbody>
</Table>

</Col>
  </Row>
</Container>

<Footer /> 



    </>



  );
}
}
export default emergencyrequest;